//日志上报组件的相关配置
export const config = {
	//日志在localStorage中的key
	LOG_CACHE_KEY: "xkw_io_logs",
	//日志内容中间的分隔符
	LOG_SEPERATOR:"@@@@",
	//默认记录的日志级别
	DEFAULT_RECORD_LEVELS: ["log", "info", "error", "debug"],
	//接口地址，会被webpack.dev.js中的DefinePlugin替换为env.prod|test.js中的值
	//eslint-disable-next-line
	LOG_REPORT_API_URL: `${LOG_REPORT_API_URL}`,
	//缓存中缓存的最大日志数量
	LOG_CACHE_MAX_LENGTH: 100,
	//timer poll interval，定时器轮询时间间隔，毫秒为单位
	TIMER_POLL_INTERVAL: 1000
};
